var defaultStrings = require("../intl/en.json");

var languageMetadata = require("../data/translations.json");

var supportedLanguages = Object.keys(languageMetadata); // Returns language's content version
// Used for conditional rendering of content

var getLangContentVersion = function getLangContentVersion(lang) {
  var metadata = languageMetadata[lang];

  if (!metadata) {
    console.error("No metadata found for language: " + lang);
    return;
  }

  var version = metadata.version;

  if (!version) {
    console.error("No version found for language: " + lang);
    return;
  }

  return version;
}; // Returns the en.json value


var getDefaultMessage = function getDefaultMessage(key) {
  var defaultMessage = defaultStrings[key];

  if (defaultMessage === undefined) {
    console.error("No key \"" + key + "\" in en.json. Cannot provide a default message.");
  }

  return defaultMessage || "";
};

var isLangRightToLeft = function isLangRightToLeft(lang) {
  return lang === "ar" || lang === "fa";
};

var translateMessageId = function translateMessageId(id, intl) {
  if (!id) {
    console.error("No id provided for translation.");
    return "";
  }

  if (!intl || !intl.formatMessage) {
    console.error("Invalid/no intl provided for translation id " + id);
    return "";
  }

  var translation = intl.formatMessage({
    id: id,
    defaultMessage: getDefaultMessage(id)
  });

  if (translation === id) {
    console.error("Intl ID string \"" + id + "\" has no match. Default message of \"\" returned.");
    return "";
  }

  return translation;
}; // Must export using ES5 to import in gatsby-node.js


module.exports.languageMetadata = languageMetadata;
module.exports.supportedLanguages = supportedLanguages;
module.exports.getLangContentVersion = getLangContentVersion;
module.exports.getDefaultMessage = getDefaultMessage;
module.exports.isLangRightToLeft = isLangRightToLeft;
module.exports.translateMessageId = translateMessageId;